import React from "react";
import { IconT } from "types/utils";

const ArrowRightIcon = ({ height = "12", width = "12", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" aria-hidden>
      <path d="M5 10h9M11 6l4 4-4 4" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export default ArrowRightIcon;
